<template>
  <div class="supplierDeliveryOrder">
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>

    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :rowStyle="rowStyle"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :precision="item.precision"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <!-- 发货方式 -->
            <!-- <span v-if="item.field === 'deliverMethod'">{{
              transferSelectLabel(scope.row[item.field], deliverMethodOptions)
            }}</span> -->
            <span v-if="item.field === 'directDeliver'">{{
              transferSelectLabel(scope.row[item.field], directDeliverOptions)
            }}</span>
            <span v-else-if="item.field === 'instructionStatus'">{{
              transferSelectLabel(scope.row[item.field], instructionStatusOptions)
            }}</span>
            <span v-else-if="item.field === 'businessMode'">{{
              transferSelectLabel(scope.row[item.field], businessModeList)
            }}</span>
            <span v-else-if="item.field === 'distributionMode'">{{
              transferSelectLabel(scope.row[item.field], deliveryOptions)
            }}</span>
            <span v-else-if="item.field === 'unit'">{{
              transferSelectLabel(scope.row[item.field], unitOptions)
            }}</span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <creat-dialog ref="creatDialog"></creat-dialog>
    <!-- sunxueping 添加批量导入 -->
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token }"
      :isShowDownTemplateBtn="true"
    ></sirui-upload>
    <!-- 打印弹框 -->
    <PrintDialog ref="printDialogRef" :apiUrl="printApi" />
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/wareHouse/materialTradeSupplierDeliveryOrder.js';
  import BASEAPI from '@/api/dataBase.js';
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';
  import { getUserCompanyList, filterEmpty } from '@/common/js/util';
  import creatDialog from './components/creatDialog';
  import siruiUpload from '@/components/SiruiUpload';
  export default {
    name: 'materiaSupplierDeliveryOrder',
    components: {
      SiruiSearch,
      creatDialog,
      siruiUpload,
    },
    mixins: [tableMixins],
    data() {
      return {
        query: {
          instructionNo: null, //发货指令编号
          partnerNo: null, //供应商
          purchaseContractNo: null, //采购合同号
          instructionStatus: null, //发货指令状态
          instructionCreateStartDate: null, //创建日期起
          instructionCreateEndDate: null, //创建日期止
          expectArrivalStartDate: null, //预计到货日期起
          expectArrivalEndDate: null, //预计到货日期止
          deliverStartDate: null, //发货日期起
          deliverEndDate: null, //发货日期止
          instructionCompanyNo: null, //公司
          instructionCompanyName: null, //公司
          instructionDepartmentNo: null, //部门
          salesmanNo: null, //业务员
          instructionCreatePersonNo: null, //制单人
          productNo: null, //商品
          externalContractNo: null, //外部合同号
          businessInboundBatchNo: null, // 入库批次号
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        load: false,
        tableData: [],
        columnList: [],
        printApi: API.PRINT_API,
        action: API.IMPORT_SHIPPINGINSTRUCTION,
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'instructionNo',
            title: '发货指令编号',
            fixed: 'left',
            width: 220,
            visible: true,
          },
          {
            field: 'instructionCompanyName',
            title: 'supplierDeliveryOrder.search.companyName',
            visible: true,
          },
          {
            field: 'instructionDepartmentName',
            title: 'supplierDeliveryOrder.search.departmentName',
            visible: true,
          },
          {
            field: 'externalContractNo',
            title: '外部合同号',
            visible: true,
            width: 180,
          },
          {
            field: 'instructionStatus',
            title: 'supplierDeliveryOrder.search.instructionStatus',
            visible: true,
          },
          { field: 'partnerName', title: 'supplierDeliveryOrder.table.partnerName', visible: true },
          { field: 'productDesc', title: 'supplierDeliveryOrder.table.productDesc', visible: true },
          {
            field: 'instructionNumber',
            title: 'supplierDeliveryOrder.table.instructionNumber',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          {
            field: 'businessInboundQuantity',
            title: 'supplierDeliveryOrder.table.businessInboundQuantity',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          { field: 'businessVariablePriceWithTax', title: '业务结算价含税金额', visible: true }, // 后端字段未给
          {
            field: 'instructionCreateDate',
            title: 'supplierDeliveryOrder.table.instructionCreateDate',
            visible: true,
          },
          { field: 'contractName', title: '合同名称', visible: true, width: 180 },
          { field: 'deliverDate', title: 'supplierDeliveryOrder.table.deliverDate', visible: true },
          {
            field: 'purchaseContractNo',
            title: 'supplierDeliveryOrder.search.purchaseContractNo',
            visible: true,
            width: 180,
          },
          {
            field: 'deliverFromAddress',
            title: 'supplierDeliveryOrder.table.deliverFromAddress',
            visible: true,
          },
          {
            field: 'salesmanName',
            title: 'supplierDeliveryOrder.search.salesmanName',
            visible: true,
          },
          {
            field: 'businessMode',
            title: '业务性质',
            visible: true,
          },
          {
            field: 'instructionCreatePersonName',
            title: 'supplierDeliveryOrder.search.createPersonName',
            visible: true,
          },
          { field: 'unit', title: 'supplierDeliveryOrder.table.unit', visible: true },

          {
            field: 'contractNo',
            title: 'supplierDeliveryOrder.table.contractNo',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          {
            field: 'inboundQuantity',
            title: 'supplierDeliveryOrder.table.inboundQuantity',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          {
            field: 'expectArrivalDate',
            title: 'supplierDeliveryOrder.table.expectArrivalDate',
            visible: true,
          },
          { field: 'shippingMark', title: 'supplierDeliveryOrder.table.mark', visible: true },
          { field: 'businessInboundNo', title: '业务入库单号', visible: true },
          { field: 'businessInboundBatchNo', title: '入库批次号', visible: true },
          { field: 'businessVariablePrice', title: '业务结算价', visible: true },
          { field: 'businessContractPrice', title: '合同价', visible: true }, // 后端字段未给
          { field: 'businessContractPriceWithTax', title: '合同价含税金额', visible: true }, // 后端字段未给
          { field: 'businessContractPricePureAmount', title: '合同净值价', visible: true }, // 后端字段未给
          { field: 'businessContractPriceTaxAmount', title: '合同价税额', visible: true }, // 后端字段未给
          { field: 'matchedQuantity', title: '已匹配数量', visible: true }, // 后端字段未给
          { field: 'matchAvailableQuantity', title: '可匹配数量', visible: true }, // 后端字段未给
          { field: 'taxRate', title: '税率', visible: true }, // 后端字段未给
          { field: 'inboundDate', title: '业务入库日期', visible: true }, // 后端字段未给
          // { field: 'isRelatedOtherInstruction', title: '是否关联供应商发货指令', visible: true }, // 后端字段未给
          // { field: 'relatedInstructionNo', title: '关联供应商发货指令号', visible: true }, // 后端字段未给
          { field: 'platformCompanyName', title: '平台公司名称', visible: true },
          // { field: 'baseName', title: '基地简称', visible: true },
          { field: 'carNo', title: '车牌号', visible: true },
          { field: 'spec', title: '规格', visible: true },
          { field: 'documentNo', title: '纸质单据号', visible: true },
        ],
        directDeliverOptions: [], //是否直拨下拉
        instructionStatusOptions: [], //发货指令状态下拉
        companyList: getUserCompanyList(),
        departmentList: [], //部门列表
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        //运输方式下拉
        deliveryOptions(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'delivery_method').dictList;
          }
        },
        //单位下拉1
        unitOptions(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'basic_unit').dictList;
          }
        },
        // 业务性质下拉
        businessModeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'purchase_business_type')
              .dictList;
          }
        },
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
          businessGroup: this.userInfo.businessGroup,
        };
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'instructionNo',
            name: '供应商发货指令编号',
            type: 'input',
            placeholder: this.$t('supplierDeliveryOrder.search.instructionNoPlaceholder'),
          },
          //供应商  下拉选择
          {
            type: 'searchTableSpec',
            name: this.$t('contractAgency.supplier'),
            prop: 'partnerNo',
            searchType: 'supplier',
            propCode: 'partnerCode',
            propName: 'partnerZhName',
            extraData: {
              departmentCode: this.query.instructionDepartmentNo, //部门
              companyCode: this.query.instructionCompanyNo, //公司
            },
            isMultiple: true,
          },
          {
            prop: 'instructionCompanyNo',
            name: this.$t('supplierDeliveryOrder.search.companyName'),
            type: 'select',
            placeholder: this.$t('payablesBillList.search.companyCodePlaceholder'),
            options: this.companyList,
            relatedColumn: 'none',
            clearable: false,
            changeMethod: 'searchCompanyName',
          },
          //部门
          {
            prop: 'instructionDepartmentNo',
            name: this.$t('supplierDeliveryOrder.search.departmentName'),
            type: 'select',
            options: this.departmentList,
          },
          {
            prop: 'purchaseContractNo',
            name: this.$t('supplierDeliveryOrder.search.purchaseContractNo'),
            type: 'input',
            placeholder: this.$t('supplierDeliveryOrder.search.purchaseContractNoPlaceholder'),
          },
          {
            prop: 'instructionStatus',
            name: this.$t('supplierDeliveryOrder.search.instructionStatus'),
            type: 'select',
            placeholder: this.$t('supplierDeliveryOrder.search.instructionStatusPlaceholder'),
            options: this.instructionStatusOptions,
          },
          //商品
          {
            type: 'searchTableSpec',
            prop: 'productNo',
            name: '商品',
            isMultiple: true,
            searchType: 'usableProduct',
            extraData: {
              detailProductStatus: 'ZT03',
              contractCategory: 'purchase',
              adminFlag: 2,
              selectCompanyCode: '',
            },
          },
          /**
           * <SearchTable
                    searchType="usableProduct"
                    isMultiple={true}
                    extraData={{
                      detailProductStatus: 'ZT03',
                      contractCategory: 'purchase',
                      adminFlag: 2,
                    }}
                    currentValue={row['productDesc']}
                    checkRowKeys={[row['productNo']]}
                    onInput={(val) => this.chooseTable(val, row, 'productDesc')}
                  ></SearchTable>
           */
          {
            prop: 'businessInboundBatchNo',
            name: '入库批次号',
            type: 'input',
            placeholder: '请输入入库批次号',
          },
          {
            prop: 'externalContractNo',
            name: '外部合同号',
            type: 'input',
            placeholder: '请输入外部合同号',
          },
        ];
      },
    },
    created() {
      //是否直拨
      this.directDeliverOptions = [
        { value: '1', label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionOne') },
        { value: '0', label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionTwo') },
      ];
      //状态下拉
      this.instructionStatusOptions = [
        { value: '0', label: this.$t('supplierDeliveryOrder.search.instructionStatusOptionOne') },
        // { value: '1', label: this.$t('supplierDeliveryOrder.search.instructionStatusOptionTwo') },
        { value: '1', label: this.$t('supplierDeliveryOrder.search.instructionStatusOptionThree') },
        { value: '3', label: '已撤销' },
        { value: '4', label: '已冲销' },
        { value: '5', label: '部分冲销' },
      ];
    },
    /**页面必要代码Start */
    mounted() {
      console.log(this.action, '-----------1111--------------------');
      this.$nextTick(() => {
        // this.query.instructionCompanyNo = this.userInfo.companyCode;
        this.getData();
        this.getButtonList();
        // this.getDepartment(this.userInfo.companyCode);
      });
    },
    methods: {
      //行项目样式
      rowStyle({ row }) {
        const isDuplicate = row.isDuplicate;
        if (isDuplicate) {
          return {
            backgroundColor: 'rgb(228, 120, 120)',
            color: '#fff',
          };
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          console.log(e, '11111111111');
          this.menuButtonList = e || [];
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then(() => {
          this.columnList = this.columnListDefault;
          // this.columnList = res.length === 0 ? this.columnListDefault : res;
        });
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.instructionDepartmentNo = '';
        this.getDepartment(val.val);
      },
      //获取部门
      async getDepartment(companyCode) {
        const selectStatus = await this.$axios.post(
          BASEAPI.LIST_DEPARTMENT_API + `/${companyCode}`
        );
        this.departmentList = selectStatus.data.data;
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        // query.instructionCompanyNo=this.userInfo.companyCode;
        if (query.partnerNo && query.partnerNo.length > 0) {
          //供应商
          query.partnerNo =
            query.partnerNo[0].partnerCode ||
            (Object.prototype.toString.call(query.partnerNo[0]).toLowerCase() == '[object object]'
              ? null
              : query.partnerNo);
          //  query.partnerNo = this.handleData(query.partnerNo, "partnerCode");//供应商
        }
        if (query.productNo && query.productNo.length > 0) {
          //商品
          query.productNo =
            query.productNo[0].productDetailCode ||
            (Object.prototype.toString.call(query.productNo[0]).toLowerCase() == '[object object]'
              ? null
              : query.productNo);
          //  query.productNo = this.handleData(query.productNo, "productDetailCode");//商品描述
        }
        if (query.salesmanNo && query.salesmanNo.length > 0) {
          //业务员
          query.salesmanNo = query.salesmanNo[0].id || query.salesmanNo;
        }
        // query.instructionCompanyName=this.userInfo.companyName;
        // query.instructionCompanyNo=this.userInfo.companyNo;
        if (query.instructionCreatePersonNo && query.instructionCreatePersonNo.length > 0) {
          //制单人
          query.instructionCreatePersonNo =
            query.instructionCreatePersonNo[0].id || query.instructionCreatePersonNo;
        }
        // query 里已没有该字段
        // if (query.storageNo && query.storageNo.length > 0) {
        //   //仓库
        //   query.storageNo = query.storageNo[0].storageCode || query.storageNo;
        // }
        this.$axios.post(API.GET_DATA_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.tableData.forEach((table) => {
              if (table.instructionStatus === '3' || table.instructionStatus === '0') {
                table.businessInboundBatchNo = '';
                table.businessInboundNo = '';
              }
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      chooseClick(type) {
        console.log(type, this.userInfo);
        if (type == 'add') {
          //新增
          //进入引用合同页面，现在是打开创建页面
          this.$refs.creatDialog.defaultVisible = true;
          // this.$refs.creatDialog.extraData.departmentCode = this.userInfo.departmentCode;
        } else if (type == 'import') {
          this.handleImport();
        } else if (type == 'export') {
          this.export();
        } else if (type === 'batchDelete') {
          this.handleBatchDelete();
        } else if (type == 'copy') {
          this.copyContract();
        } else if (type == 'print') {
          // 打印
          if (this.multipleSelection.length != 1) {
            this.$message.warning('请选择一行操作');
            return;
          }
          if (!['1', '4'].includes(this.multipleSelection[0].instructionStatus)) {
            this.$message.warning('请选择有效的行');
            return;
          }
          this.$refs.printDialogRef.openDialog({
            instructionNo: this.multipleSelection[0].instructionNo,
            downloadOrPrint: 'print',
          });
        } else if (type == 'chargeAgainst') {
          if (!this.multipleSelection.length) {
            this.$message.warning('请选择行操作');
            return;
          }
          // 冲红
          this.$confirmAction('确认是否全部冲销', '')
            .then(async () => {
              const postData = this.multipleSelection.map((item) => {
                return {
                  ...item,
                  businessGroup: this.userInfo.businessGroup,
                };
              });
              const { data } = await this.$axios.post(API.WRITE_OFF_API, postData);
              if (data.code == 0) {
                this.$message.success('冲销成功');
                this.searchBtnClick();
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch(() => {
              console.log('取消');
            });
        }
      },
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true, '013');
      },
      // 复制
      copyContract() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('supplierDeliveryOrder.msg.copyContractTips'),
            type: 'error',
          });
          return;
        }
        let path = {
          path: '/wareHouse/addMateriaSupplierDeliveryOrder',
          name: 'addMateriaSupplierDeliveryOrder',
          meta: {
            keepAlive: true,
            title: '创建供应商发货指令',
          },
          //type =2：双击；type=3:复制
          query: { instructionNo: this.multipleSelection[0].instructionNo, type: 3, flag: 2 },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item.allPartnerCode);
            } else {
              list.push(item.partnerCode);
            }
          } else if (key == 'productDetailCode') {
            //合并的数据
            if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
              list.push(item.allProductDetailCode);
            } else {
              list.push(item.productDetailCode);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      // 导出
      export() {
        const query = this.$refs.siruiSearch.query;
        if (query.partnerNo && query.partnerNo.length > 0) {
          //供应商
          query.partnerNo = query.partnerNo[0].partnerCode || query.partnerNo;
          // query.partnerNo = this.handleData(query.partnerNo, 'partnerCode'); //供应商
        }
        // query.instructionCompanyNo=this.userInfo.companyCode;//供应商发货指令公司
        if (query.productNo && query.productNo.length > 0) {
          //商品
          query.productNo = query.productNo[0].productDetailCode || query.productNo;
          // query.productNo = this.handleData(query.productNo, 'productDetailCode'); //商品描述
        }
        if (query.salesmanNo && query.salesmanNo.length > 0) {
          //业务员
          query.salesmanNo = query.salesmanNo[0].id || query.salesmanNo;
        }
        if (query.instructionCreatePersonNo && query.instructionCreatePersonNo.length > 0) {
          //制单人
          query.instructionCreatePersonNo =
            query.instructionCreatePersonNo[0].id || query.instructionCreatePersonNo;
        }
        if (query.storageNo && query.storageNo.length > 0) {
          //仓库
          query.storageNo = query.storageNo[0].storageCode || query.storageNo;
        }
        let ids = [];
        const params = filterEmpty(query);
        params.businessGroup = this.userInfo.businessGroup;
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            ids.push(item.id);
          });
        }
        if (!ids.length) {
          this.$confirmAction('提示', '未选中导出单据,系统将按查询条件导出,是否继续?')
            .then(async () => {
              // 获取数据
              this.$axios.post(API.EXPORT_SHIPPINGINSTRUCTION, filterEmpty(params)).then((res) => {
                if (res.data.code === 0) {
                  window.location.href = res.data.data;
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              return false;
            });
        } else {
          // 去重
          const selectedIds = [...new Set(ids)];
          params.ids = selectedIds;
          params.businessGroup = this.userInfo.businessGroup;
          // 获取数据
          this.$axios.post(API.EXPORT_SHIPPINGINSTRUCTION, filterEmpty(params)).then((res) => {
            if (res.data.code === 0) {
              window.location.href = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      dblclickEvent(value) {
        let path = {
          path: '/wareHouse/addMateriaSupplierDeliveryOrder',
          name: 'addMateriaSupplierDeliveryOrder',
          meta: {
            keepAlive: true,
            title: '供应商发货指令维护',
          },
          query: { instructionNo: value.row.instructionNo, type: 2, flag: 2 },
        };
        if (value.row.instructionStatus == '1' || value.row.instructionStatus == '2') {
          // path.path = '/wareHouse/supplierDeliveryDetail';
          // path.name = 'supplierDeliveryDetail';
          path.query.disable = true;
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleBatchDelete() {
        console.log(this.multipleSelection, 'handleBatchDelete');
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            message: '请选择数据',
            type: 'warning',
          });
        }
        const ids = [];
        let isDelete = true;
        this.multipleSelection.forEach((item) => {
          if (['1', '4', '5'].includes(item.instructionStatus)) {
            isDelete = false;
          }
          ids.push(item.id);
        });
        if (!isDelete) return this.$message.error("只能删除'已保存'和'已撤回'状态的数据");
        this.$axios.post(API.BATCH_DELETE, ids).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.getData();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //下拉中文转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .supplierDeliveryOrder {
    .instructionNoClick {
      text-decoration: underline;
      color: blue;
      cursor: pointer;
    }
  }
</style>
